import { Modal, Box, Fade, Grid, useMediaQuery, Divider } from "@mui/material";
import { Close } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useTheme } from "@emotion/react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import React, { useState } from "react";
import { getApiData } from "../../utils/APIHelper";
import { Setting } from "../../utils/Setting";
import { toast } from "react-toastify";
import { styled } from "@mui/material/styles";
import Images from "../../config/images";

const StyledButton = styled(Button)(({ theme }) => ({
  background: "#4D6BF6",
  color: "#ffffff",
  boxShadow: "none",
  border: "1px solid #4D6BF6",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: "8px 16px",
}));

const GreyStyledButton = styled(Button)(({ theme }) => ({
  background: "#ffffff",
  color: "#0D0D0E",
  boxShadow: "none",
  border: "1px solid #D7D8D9",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: "8px 16px",
}));

export default function RequestInspectionModal({
  isOpen,
  handleClose,
  paymentGroup,
  getProjectDetails,
}) {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down("sm"));
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: sm ? 300 : 500,
    bgcolor: "background.paper",
    borderRadius: 1,
    boxShadow: 24,
    p: "2vh 2vw",
    fontFamily: "Inter Tight",
  };
  const [inspectionDate, setInspectionDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);

  const handleRequestInspection = async () => {
    const payload = {
      groupId: paymentGroup?.group_id,
      inspectionDate: moment(inspectionDate).toISOString(),
      requested: true,
    };

    setIsLoading(true);
    try {
      await getApiData(
        `${Setting.endpoints.inspections}`,
        "PUT",
        payload,
        false,
        true
      );
      toast.success("Inspection requested successfully");
      handleClose();
      getProjectDetails();
    } catch (error) {
      toast.error(error.toString());
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Fade in={isOpen}>
        <Box sx={style}>
          <Grid container justifyContent="space-between" alignItems="center">
            <div className="addMilestoneHeader">Request Inspection</div>
            <Close onClick={handleClose} style={{ cursor: "pointer" }} />
          </Grid>

          <div style={{ margin: "3vh 0 4vh 0" }}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label="Inspection Date"
                disablePast
                value={inspectionDate}
                onChange={(date) => setInspectionDate(date)}
                components={{
                  OpenPickerIcon: () => (
                    <img src={Images.calendarIcon} alt="calendar-icon" />
                  ),
                }}
                slotProps={{
                  textField: {
                    fullWidth: true,
                  },
                }}
                format="MMMM dd, yyyy"
              />
            </LocalizationProvider>
          </div>

          <Divider style={{ marginTop: "2vh" }} />
          <Grid
            item
            container
            justifyContent="center"
            gap={sm ? 1 : 2}
            wrap="nowrap"
            marginTop="10px"
          >
            <Grid
              item
              xs={6}
              sx={{ display: "flex", justifyContent: "flex-start" }}
            >
              <GreyStyledButton onClick={handleClose}>Cancel</GreyStyledButton>
            </Grid>

            <Grid
              item
              xs={6}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <StyledButton
                variant="contained"
                onClick={handleRequestInspection}
                disabled={isLoading}
              >
                Submit
              </StyledButton>
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
}
